import React from "react";
import {
    Box,
    Container,
    TextField,
    ThemeProvider,
    Paper,
    Typography,
    createMuiTheme,
    makeStyles,
} from "@material-ui/core";
import TopImage from "./top.png";

const useStyles = makeStyles(() => ({
    head: {
        width: "100%",
        top: 0,
        position: "sticky",
        zIndex: 10,
    },
    image: {
        display: "block",
        margin: "auto",
    },
    searchBox: {
        textAlign: "center",
    },
    count: {
        textAlign: "center",
    },
}));

type Props = {
    totalCount?: number;
    onChangeKeywords: (keywords: string) => void;
};

export function Header(props: Props) {
    const theme = createMuiTheme({
        palette: {
            background: { paper: "#7f38b0" },
            text: { primary: "#ffffff" },
            primary: { main: "#c6a0e1" },
            action: { focus: "#ffffff" },
        },
        overrides: {
            MuiInput: {
                underline: {
                    "&:before": {
                        borderBottomColor: "rgba(255, 255, 255, 0.4)",
                    },
                },
            },
        },
        typography: {
            fontFamily: '"Hiragino Maru Gothic ProN", Meiryo',
            fontSize: 14,
            body1: {
                lineHeight: 1.6,
            },
            body2: {
                fontFamily: 'Georgia, "Hiragino Mincho ProN W3"',
                fontSize: "1rem",
                lineHeight: 1.6,
            },
        },
    });
    const styles = useStyles();

    return (
        <ThemeProvider theme={theme}>
            <Paper className={styles.head} elevation={3} square>
                <Container maxWidth="sm">
                    <img src={TopImage} className={styles.image} />
                    <Box className={styles.searchBox}>
                        <TextField onChange={(e) => props.onChangeKeywords(e.target.value)} placeholder="Search" />
                    </Box>
                    <Box className={styles.count}>
                        <Typography variant="body2">
                            {props.totalCount != undefined ? `${props.totalCount}\u2005posts` : "\u00a0"}
                        </Typography>
                    </Box>
                </Container>
            </Paper>
        </ThemeProvider>
    );
}
